<mat-dialog-content>
  <div class="dialog-content">
    <h2>Are You Sure?</h2>
    <p>
      Remove temporary hand-off outage for {{ plannedHandoffException.startOn | date: "fullDate" }} through
      {{ plannedHandoffException.endOn | date: "fullDate" }}
    </p>
    <div class="button-container">
      <button mat-button (click)="confirm(false)">Cancel</button>
      <button mat-raised-button color="warn" (click)="confirm(true)">Remove</button>
    </div>
  </div>
</mat-dialog-content>
